import './styles/score.css';
import { useGameStore } from '../../store/gameStore';
import { useShallow } from 'zustand/shallow';
import { useEffect, useRef, useState } from 'react';

function Score() {
  const { points } = useGameStore(
    useShallow((state) => ({
      points: state.gameData[state.mode].points,
    }))
  );

  const prevPointsRef = useRef(points);
  const [count, setCount] = useState(points);
  const [recentGain, setRecentGain] = useState<number | null>(null);

  useEffect(() => {
    const prev = prevPointsRef.current;

    if (points > prev) {
      const gain = points - prev;

      setRecentGain(gain);
      setCount(prev);

      const flashTimeout = setTimeout(() => {
        setRecentGain(null);
        animateScore(prev, points);
      }, 1200);

      prevPointsRef.current = points;
      return () => clearTimeout(flashTimeout);
    }

    if (points <= prev) {
      setCount(points);
      prevPointsRef.current = points;
    }
  }, [points]);

  const animateScore = (from: number, to: number) => {
    let current = from;

    const animate = () => {
      if (current >= to) return;

      const progress = (current - from) / (to - from);
      const delay = 30 + progress * 50;

      const timer = setTimeout(() => {
        current += 1;
        setCount(current);
        animate();
      }, delay);

      return () => clearTimeout(timer);
    };

    animate();
  };

  return (
    <div className="score-container">
      <div className="score-text">Score</div>
      <div className="score-number">
        {recentGain !== null ? (
          <span className="flex space-x-0.5">
            {`+${recentGain}`.split('').map((char, idx) => (
              <span
                key={idx}
                className="pulse-once inline-block"
                style={{ animationDelay: `${idx * 0.15}s`, animationFillMode: 'forwards' }}
              >
                {char}
              </span>
            ))}
          </span>
        ) : (
          count
        )}
      </div>
    </div>
  );
}

export default Score;
